<template>
  <ContactModal
    data-test-id="ContactSalesModal__base"
    :isChatButtonLoading="isChatLoading"
    :showChatOption="typeof scheduleCallButtonClicked === 'function'"
    :showModal="showModal"
    title="Contact Sales"
    @close="$emit('close')"
    @onCall="scheduleCallButtonClicked"
    @onChat="handleChatButtonClick(modalName)"
    @onEmail="emailButtonClicked"
  />
</template>

<script>
import { paymentModalNames } from 'client/GrowthEngineering/utilities/GrowthConstants';
import PaymentStepMixin from 'client/Payments/mixins/PaymentStepMixin';
import Util from 'client/util/Util';

import ContactModal from 'client/components/Modal/ContactModal.vue';

export default {
  name: 'ContactSales',

  components: {
    ContactModal,
  },

  mixins: [PaymentStepMixin],

  Util,

  props: {
    handleChatButtonClick: {
      type: Function,
      default: () => {},
    },
    isChatLoading: Boolean,
    showModal: Boolean,
  },

  data() {
    return {
      modalName: paymentModalNames.paymentContactSalesModal,
    };
  },

  methods: {
    emailButtonClicked() {
      this.$options.Util.openUrl('mailto:sales@jumpcloud.com');
      this.handleEmailSalesLinkClicked(this.modalName);
    },

    scheduleCallButtonClicked() {
      this.$options.Util.openUrl(this.calendlyLink);
      this.handleCalendlyLinkClicked(this.modalName);
    },
  },
};
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  margin-top: 24px;
}

.ctaHeader {
  text-align: left;
}

.ctaWrapper {
  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-spacer);
  justify-content: center;
  margin-bottom: var(--jc-spacer-medium);
  padding: 0 var(--jc-spacer-medium);
  text-align: center;
}

.footer {
  background-color: var(--jcPrimary50);
  bottom: 0;
  height: 7rem;
  padding: var(--jc-spacer-medium) 0 var(--jc-spacer);
  position: sticky;
  text-align: center;
}
</style>
